import I18n from "@/i18n-js/instance";
import { Icon } from "@circle-react/components/shared/Icon";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { CircularProgress } from "./CircularProgress";

export interface CancelButtonWithProgressProps {
  isUploading: boolean;
  progress: number;
  queuedForCancellation: any;
  removeCurrentAttachment: () => void;
}

export const CancelButtonWithProgress = ({
  queuedForCancellation,
  removeCurrentAttachment,
  progress,
  isUploading,
}: CancelButtonWithProgressProps) => (
  <button
    type="button"
    onClick={e => {
      queuedForCancellation.current = true;
      removeCurrentAttachment();
      e.preventDefault();
    }}
    className={classNames(
      "group/close-button bg-primary absolute -right-3 -top-3 flex cursor-pointer items-center justify-center rounded-full",
      {
        "hidden group-hover:block": !isUploading,
      },
    )}
  >
    {isUploading && (
      <div className="m-1 flex !h-4 !w-4 items-center justify-center group-hover/close-button:hidden">
        <CircularProgress percentage={progress} size={14} strokeWidth={2} />
      </div>
    )}
    <TippyV2 content={I18n.t("tiptap.remove_attachment")}>
      <div
        className={classNames({
          "hidden group-hover/close-button:block": isUploading,
        })}
      >
        <Icon type="16-close-rounded" className="m-1 !h-4 !w-4" size={16} />
      </div>
    </TippyV2>
  </button>
);
